import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Assuming you're using React Router
import "../css/Login.css"; // Add your styles here or use styled-components

const LoginScreen = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const navigate = useNavigate(); // Hook for navigation

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError(""); // Clear error on input change
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEmailError("");
        setPasswordError("");
    
        // Validate input
        if (!email.includes("@")) {
            setEmailError("Please enter a valid email.");
            return;
        } else if (!password) {
            setPasswordError("Please enter your password.");
            return;
        }
    
        // Send a POST request to the login endpoint
        try {
            const response = await fetch("http://127.0.0.1:8000/login/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: email,
                    password: password,
                }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                alert("Login successful!");
                console.log("Token:", data.token); // Store the token in localStorage or context
                // Navigate to a protected route or dashboard
                // Storing the email in localStorage
                localStorage.setItem("user", JSON.stringify({ email }));
                navigate("/");
            } else {
                alert(data.error || "Login failed. Please check your credentials.");
            }
        } catch (error) {
            console.error("Error logging in:", error);
            alert("Something went wrong. Please try again.");
        }
    };
    

    const handleBackToHome = () => {
        navigate("/"); // Navigate to home route
    };

    return (
        <div className="login-container">
            {/* Back to Home Link */}
            <div className="back-to-home-link" onClick={handleBackToHome}>
                &larr; Back to Home
            </div>

            <div className="login-modal">
                <h2>Login to Your Account</h2>
                <p>
                    Don't have an account?{" "}
                    <a href="/signup" className="signup-link">
                        Sign Up
                    </a>
                </p>

                <form onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <label className="form-label">
                        Email Address
                        <input
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="yourname@domain.com"
                            className={`form-input ${emailError ? "error" : ""}`}
                        />
                        {emailError && <div className="error-message">{emailError}</div>}
                    </label>

                    {/* Password Field */}
                    <label className="form-label">
                        Password
                        <input
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            placeholder="Password"
                            className={`form-input ${passwordError ? "error" : ""}`}
                        />
                        {passwordError && <div className="error-message">{passwordError}</div>}
                    </label>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="submit-button"
                    >
                        Login
                    </button>
                </form>

                <div className="alternative-login">
                    <p>or</p>
                    {/* Google Login Button */}
                    <div className="google-login">
                        <button className="google-button">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/><path d="M1 1h22v22H1z" fill="none"/></svg>
                            Sign up with Google
                        </button>
                    </div>

                    {/* Facebook Login Button */}
                    <div className="facebook-login">
                        <button className="facebook-button">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Facebook_f_logo_%282019%29.svg/512px-Facebook_f_logo_%282019%29.svg.png"
                                alt="Facebook Logo"
                                className="auth-logo"
                            />
                            Login with Facebook
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginScreen;
